import React from 'react';
import SearchAssist from '../../features/search/SearchAssist';
import { useSearchEditing } from '../../features/search/SearchEditingContext';
import { useQuery } from '@tanstack/react-query';
import { useUserStore } from '../../stores/userStore';
import { useWebLocale } from '../../contexts/WebLocaleContext';
import { discoveryApi } from '../../api/discovery';
import SearchHomeContent from '../../features/search/SearchHomeContent';
import { RecommendationTracking } from '../../features/discovery/RecommendationTracking';
import SearchBridges from '../../features/discovery/SearchBridges';
import PageLayout from '../../components/layout/PageLayout';
import SEO from '../../components/common/SEO';
import '../../styles/AppParity.css';
export default function SearchHome() {
  const editing = useSearchEditing();
  const { t, locale } = useWebLocale();
  const userId = useUserStore((state) => state.user?.id);
  const query = useQuery({
    queryKey: ['web-discovery', userId || 'guest', 'search', locale],
    queryFn: ({ signal }) =>
      discoveryApi.albums({
        authenticated: Boolean(userId),
        signal,
        albumSize: 4,
        includeSupportingContent: true,
        includeTracks: true,
      }),
    enabled: !editing?.active,
    staleTime: 6 * 3600000,
    retry: false,
  });
  const home = useQuery({
    queryKey: ['web-parity', 'explore'],
    queryFn: ({ signal }) => discoveryApi.home(signal),
    staleTime: 300000,
  });
  return (
    <PageLayout paddingTop={{ xs: 0, md: 0 }} paddingBottom="24px">
      <div className="pp-parity pp-search-home-page">
        <SEO title={t('search')} />
        {editing?.active && <SearchAssist />}
        <div hidden={Boolean(editing?.active)}>
          <RecommendationTracking key={userId || 'guest'} userId={userId}>
            <SearchHomeContent query={query} homeQuery={home}>
              <SearchBridges data={query.data} home={home.data} />
            </SearchHomeContent>
          </RecommendationTracking>
        </div>
      </div>
    </PageLayout>
  );
}
